import { render, staticRenderFns } from "./PayerBalance.vue?vue&type=template&id=3041bcdd&scoped=true"
import script from "./PayerBalance.vue?vue&type=script&lang=js"
export * from "./PayerBalance.vue?vue&type=script&lang=js"
import style0 from "./PayerBalance.vue?vue&type=style&index=0&id=3041bcdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041bcdd",
  null
  
)

export default component.exports